'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import '@digdir/designsystemet-web';

/**
 * A component for rendering individual options in the Suggestion list.
 *
 * @example
 * <Suggestion>
 *   <Suggestion.Input />
 *   <Suggestion.List>
 *     <Suggestion.Option value='Option 1'>Option 1</Suggestion.Option>
 *     <Suggestion.Option value='Option 2'>Option 2</Suggestion.Option>
 *   </Suggestion.List>
 * </Suggestion>
 */
const SuggestionOption = forwardRef(function SuggestionOption({ className, ...rest }, ref) {
    return (jsx("u-option", { class: className, ref: ref, suppressHydrationWarning // Since <u-option> adds attributes
        : true, ...rest }));
});

export { SuggestionOption };
